/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_ModalitiesInputs */

const en_us2_profile_row_modalities = /** @type {(inputs: Profile_Row_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you've trained before`)
};

const pt_br2_profile_row_modalities = /** @type {(inputs: Profile_Row_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que você já treinou`)
};

const es_419_profile_row_modalities = /** @type {(inputs: Profile_Row_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que ya entrenaste`)
};

const pt_pt2_profile_row_modalities = /** @type {(inputs: Profile_Row_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que já treinaste`)
};

const fr_fr2_profile_row_modalities = /** @type {(inputs: Profile_Row_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que tu as déjà pratiqué`)
};

const de_de2_profile_row_modalities = /** @type {(inputs: Profile_Row_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was du schon trainiert hast`)
};

const it_it2_profile_row_modalities = /** @type {(inputs: Profile_Row_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa hai già praticato`)
};

/**
* | output |
* | --- |
* | "What you've trained before" |
*
* @param {Profile_Row_ModalitiesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_modalities = /** @type {((inputs?: Profile_Row_ModalitiesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_ModalitiesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_modalities(inputs)
	if (locale === "es-419") return es_419_profile_row_modalities(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_modalities(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_modalities(inputs)
	if (locale === "de-DE") return de_de2_profile_row_modalities(inputs)
	if (locale === "it-IT") return it_it2_profile_row_modalities(inputs)
	return en_us2_profile_row_modalities(inputs)
});
export { profile_row_modalities as "profile.row_modalities" }